module.exports = __webpack_public_path__ + "static/media/dragon.243756d0.svg";